import TabelaProdap from "features/shared/components/TabelaProdap";
import React from "react";
import { useUserListColumns } from "../hooks/useUserListColumns";
import type { GetUsersFn, User } from "../userList.types";
import UserListEmpty from "./userListEmpty";

type UserListProps = {
  isFilterEmpty: boolean;
  getUsers: GetUsersFn;
  lastUpdate: number;
  onChangeStatus: (user: User) => void;
  onCopyLink: (user: User) => Promise<void>;
  onEdit: (user: User) => void;
  onSendLink: (user: User) => Promise<void>;
};

const UserList = ({
  isFilterEmpty,
  getUsers,
  lastUpdate,
  onEdit,
  onSendLink,
  onCopyLink,
  onChangeStatus,
}: UserListProps) => {
  const { columns } = useUserListColumns({
    onChangeStatus,
    onCopyLink,
    onEdit,
    onSendLink,
  });

  return (
    <div>
      <TabelaProdap
        servico={getUsers}
        atualizar={lastUpdate}
        colunas={columns}
        ComponenteListaVazia={() => (
          <UserListEmpty isFilterEmpty={isFilterEmpty} />
        )}
        tabelaEsquerda={true}
        ativarPaginacao={true}
      />
    </div>
  );
};

export default UserList;
